import {partial} from 'filesize'

export default partial({base: 2, standard: 'jedec', roundingMethod: 'floor'})
